import React, { useState } from "react";

import waZipCodes from "../helpers/wa-zip-codes";

const WAResidentConfirmation = (props) => {
    const {isWAResident, setIsWAResident} = props;
    const [zipcode, setZipcode] = useState('');

    const handleClick = () => {
        if (waZipCodes.includes(zipcode)) {
            setIsWAResident(isWAResident => ({...isWAResident, isConfirmed: true, zipCode: zipcode}));
        } else if (zipcode.length === 5 && !waZipCodes.includes(zipcode)) {
            setIsWAResident(isWAResident => ({...isWAResident, isConfirmed: false, zipCode: null}));
        } else {
            setIsWAResident(isWAResident => ({...isWAResident, isConfirmed: null, zipCode: null}));
        }
    }

    return (
        <>
            <div className="wa-resident-confirmation">
                <label>Please confirm your zip code</label>
                <input
                    type="text"
                    placeholder="-----"
                    className={`
                        ${(isWAResident.isConfirmed === false ? 'error' : '')}
                        ${(isWAResident.isConfirmed === true ? 'success' : '')}
                    `}
                    onChange={(e) => setZipcode(e.target.value)}
                />
                <button
                    className="button"
                    disabled={zipcode.length < 5}
                    onClick={() => handleClick()}
                >
                    Confirm
                </button>
            </div>
        </>
    )
}

export default WAResidentConfirmation;

